import React from "react";
import { createContext, useContext } from "react";
import {
	type LocaleConfig,
	localeByLocaleId,
} from "../containers/route/localeByLocaleId";

const Context = createContext<LocaleConfig>(localeByLocaleId["en-us"]);

interface LocaleContextProviderProps {
	value: LocaleConfig;
}

export const LocaleContextProvider: React.FC<LocaleContextProviderProps> = ({
	children,
	value,
}) => {
	return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useLocale = () => {
	const context = useContext(Context);

	if (!context) {
		throw new Error("useLocale must be used within a LocaleContextProvider");
	}

	return context;
};
